import { useDeviceType } from '@cian/ui-kit';
import * as styles from './styles.css';
import { clsx } from 'clsx';
import { TDescriptionValue } from 'shared/types/typographyComponents';
import { Link } from 'react-scroll';

interface IDescriptionProps {
  text: TDescriptionValue[];
}

export const Description: React.FC<IDescriptionProps> = ({ text }) => {
  const device = useDeviceType();

  return (
    <span className={clsx(styles['descr'], styles[device])}>
      {text.map(({ value, url, anchorLink, isBold = false }, key) => {
        if (anchorLink) {
          return (
            <Link smooth className={styles['anchor-link']} to={anchorLink} key={key}>
              {value}
            </Link>
          );
        }

        if (url) {
          return (
            <a
              key={key}
              className={clsx(styles['link'], isBold ? styles['bold'] : '')}
              href={url}
              target="_blank"
              rel="noreferrer"
            >
              {value}
            </a>
          );
        }

        return (
          <span key={key} className={isBold ? styles['bold'] : ''}>
            {value}
          </span>
        );
      })}
    </span>
  );
};
